import { Resource as r } from "@coveo/platform-client";
import { BatchAnswerDatasetsResource as e } from "./datasets/BatchAnswerDatasets.resource.js";
import { EvaluationResource as n } from "./evaluations/BatchAnswerEvaluations.resource.js";
import { EvaluationRunResource as u } from "./runs/BatchAnswerEvaluationRuns.resource.js";
class h extends r {
  constructor(t, o) {
    super(t, o), this.dataset = new e(t, o), this.evaluation = new n(t, o), this.run = new u(t, o);
  }
}
export {
  h as BatchAnswerResource
};
//# sourceMappingURL=BatchAnswerResource.js.map
